const firstname = [
    { type: 'required', message: 'First name is required' },
    { type: 'minlength', message: 'First name must be at least 3 characters long' },
    { type: 'maxlength', message: 'First name cannot be more than 25 characters long' },
    { type: 'pattern', message: 'Your name must contain only numbers and letters' },
    // { type: 'validFirstname', message: 'Your name has already been taken' },
    // { type: 'areEqual', message: 'You entered wrong username' },
]

export default { firstname };